module.exports = __webpack_public_path__ + "img/warning.bc5bcd65.svg";